import { Box, Divider, Typography } from '@mui/material'
import ChapterList from './ChapterList'
import SectionList from './SectionList'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'

interface BookDetailsProps {}

const BookDetails: React.FC<BookDetailsProps> = () => {
  const projectName = useSelector((state: RootState) => state.rule.projectName)
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
        }}
      >
        <Typography
          sx={{
            color: '#04002E',

            fontSize: '22px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: 'normal',
          }}
        >
          {projectName}
        </Typography>
        <Typography
          sx={{
            color: '#04002E',

            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: 'normal',
            maxWidth: '350px',
          }}
        ></Typography>
      </Box>
      <Divider />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: '10px',
        }}
      >
        <ChapterList />
        <SectionList />
      </Box>
    </Box>
  )
}

export default BookDetails
